interface IValidateNameFieldArgs {
  draftName: string;
  limit: number;
  originalName: string;
  snapshotName?: string;
}

export const useValidateNameField = ({
  draftName,
  limit,
  originalName,
  snapshotName,
}: IValidateNameFieldArgs) => {
  const trimmedDraftName = draftName.trim();

  const isValid =
    trimmedDraftName.length > 0 && trimmedDraftName.length <= limit;

  const isDirty = snapshotName
    ? trimmedDraftName !== snapshotName
    : trimmedDraftName !== originalName;

  return {
    isValid,
    isDirty,
  };
};
